module.exports = {
  title: 'Stacked Modals with React Native Reanimated',
  author: 'Enzo Manuel Mangano',
  date: '2024-12-12',
  slug: 'stacked-modals',
  tags: ['reanimated'],
};
